import React, { useEffect, useState } from "react";
import Slider from "react-slick";
import "./top-grocery-stores-slider.scss";
import BrandLogo from "../../../images/kikoimg.svg";
import CardDesignShadow from "../../../images/home/card-design-shadow.svg";
import { shopBackgrounds } from "../../../components/common/utils";

const TopGroceryStoresSlider = ({ recommendedSellers = [], navigate, categoryParam }) => {
  const [shuffledBackgrounds, setShuffledBackgrounds] = useState([]);

  const shuffleArray = (array) => {
    const shuffled = [...array];
    for (let i = shuffled.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
    }
    return shuffled;
  };

  let ExcitingSettings = {
    dots: false,
    arrows: true,
    infinite: false,
    slidesToShow: 6,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 812,
        settings: {
          slidesToShow: recommendedSellers?.length > 3 ? 3 : recommendedSellers?.length,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 767,
        settings: {
          initialSlide: 0.5,
          slidesToScroll: 1,
          slidesToShow: 1.8,
        },
      },
    ],
  };

  const handleSellerClick = (seller, categoryParam) => {
    const encodedValue = encodeURIComponent(seller?.providerId);
    navigate(`seller?pid=${encodedValue}`, {
      state: {
        category: categoryParam || "All",
      },
    });
  };

  useEffect(() => {
    setShuffledBackgrounds(shuffleArray(shopBackgrounds));
  }, []);

  return (
    <>
      <div className="container">
        <div className="row">
          <div className="col-md-12">
            <Slider {...ExcitingSettings} className="top-grocery-slider-kl">
              {recommendedSellers.map((sellerDetails, index) => {
                const panIndia = sellerDetails?.serviceabilityRadius?.some(item => item.type === "12");
                const randomBg = panIndia ? sellerDetails?.photo : shuffledBackgrounds[index % shuffledBackgrounds.length]
                return (
                  <div onClick={() =>
                    handleSellerClick(sellerDetails, categoryParam)
                  } className="top-grocery-card-kl" key={index}>
                    <div className="top-grocery-card-header-kl">
                      <img className="top-grocery-card-img-kl" src={randomBg} alt={`Exciting offer ${index + 1}`} />
                      <img className="card-design-shadow" src={CardDesignShadow} alt={`Exciting offer ${index + 1}`} />

                    </div>
                    <div className="top-grocery-card-footer-kl">
                      {!panIndia && <div className="top-grocery-card-circle-kl">
                        <img src={sellerDetails?.photo ?? BrandLogo} alt="" />
                      </div>}
                    
                      <div className="top-grocery-card-title-kl">
                        {sellerDetails?.name ?? ""}
                      </div>
                      <div className="top-grocery-card-store-km-kl">
                        {sellerDetails?.distance >= 0
                          ? `${sellerDetails?.distance.toFixed(
                            2
                          )} Km`
                          : "Distance not available"}
                      </div>
                    </div>
                  </div>
                )
              })}
            </Slider>
          </div>
        </div>
      </div>
    </>
  );
};

export default TopGroceryStoresSlider;
